// extracted by mini-css-extract-plugin
module.exports = {"container":"LanguageSelectView_container__85EOx"};